var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.634,
    height: 24.54,
    viewBox: "0 0 34.634 24.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-joystick-3457789",
    transform: "translate(-132.304 -126.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M241.739,275.8a3.737,3.737,0,1,0,3.737,3.737A3.737,3.737,0,0,0,241.739,275.8Zm0,5.689a1.952,1.952,0,1,1,1.952-1.952A1.976,1.976,0,0,1,241.739,281.489Z",
    transform: "translate(-97.276 -137.221)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M375.677,279.539a3.737,3.737,0,1,0-3.737,3.737A3.81,3.81,0,0,0,375.677,279.539Zm-3.737,1.952a1.952,1.952,0,1,1,1.952-1.952A1.906,1.906,0,0,1,371.94,281.491Z",
    transform: "translate(-217.105 -137.223)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M164.652,133.114a7.666,7.666,0,0,0-7.139-6.358l-.167-.056H142.288a7.624,7.624,0,0,0-7.585,6.414l-2.287,12.214a6.148,6.148,0,0,0-.111,1,4.855,4.855,0,0,0,4.852,4.852,4.8,4.8,0,0,0,4.015-2.119l1.115-1.506a.882.882,0,0,0-1.45-1l-1.115,1.562a3.175,3.175,0,0,1-2.565,1.394,3.118,3.118,0,0,1-3.123-3.123,2.716,2.716,0,0,1,.056-.669l2.287-12.27a5.926,5.926,0,0,1,5.856-4.964h15.114a6.1,6.1,0,0,1,5.577,4.964l2.287,12.27a2.719,2.719,0,0,1,.056.669,3.136,3.136,0,0,1-5.744,1.729L158.35,146.5a.882.882,0,1,0-1.45,1l1.171,1.617a4.8,4.8,0,0,0,4.015,2.119,4.855,4.855,0,0,0,4.852-4.852,6.16,6.16,0,0,0-.111-1Z",
    transform: "translate(0 0)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M394.344,200.672a1.171,1.171,0,1,1-1.171-1.171,1.171,1.171,0,0,1,1.171,1.171",
    transform: "translate(-239.007 -67.001)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M454.541,200.672a1.171,1.171,0,1,1-1.171-1.171,1.171,1.171,0,0,1,1.171,1.171",
    transform: "translate(-294.407 -67.001)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M225.946,170.8a.881.881,0,0,0-.892.892v1.562h-1.562a.892.892,0,0,0,0,1.785h1.562V176.6a.892.892,0,1,0,1.785,0v-1.562H228.4a.892.892,0,1,0,0-1.785h-1.562v-1.562A.881.881,0,0,0,225.946,170.8Z",
    transform: "translate(-83.101 -40.587)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M424.444,230.772a1.171,1.171,0,1,1-1.171-1.171,1.171,1.171,0,0,1,1.171,1.171",
    transform: "translate(-266.708 -94.703)",
    fill: "#bec4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M424.444,170.568a1.171,1.171,0,1,1-1.171-1.171,1.171,1.171,0,0,1,1.171,1.171",
    transform: "translate(-266.708 -39.295)",
    fill: "#bec4de"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.7724b2d7593b4a3dfe0cb6be43d4371c.svg";
export { ForwardRef as ReactComponent };